



















import Vue from 'vue';
export default Vue.extend({
  name: 'GiftStatus',
  props: {
    status: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      required: true,
    },
    date: {
      type: String,
      required: false,
    },
  },
  computed: {
    statusText() {
      if (!this.active) {
        return this.$t('GIFTS.LABELS.DEACTIVATED');
      }
      switch (this.status) {
        case 'scheduled':
          return this.$t('GIFTS.LABELS.SCHEDULED');
        case 'unclaimed':
          return this.$t('GIFTS.LABELS.UNCLAIMED');
        case 'claimed':
          return this.$t('GIFTS.LABELS.CLAIMED');
        default:
          return undefined;
      }
    },
  },
});
